export default {
  dashboard: "داشبورد",
  admins: "مدیران",
  admin_create: "اضافه کردن",
  admins_list: "لیست مدیران",
  students: "دانش آموزان",
  student_create: "اضافه کردن",
  students_list: "لیست دانش اموزان",
  customers: "مشتریان",
  products_section: "مدیریت محصولات",
  product_categories: "دسته بندی محصولات",
  products: "محصولات",
  add_products: "اضافه کردن",
  add_order: "ثبت سفارش",
  orders_section: "مدیریت سفارش",
  shipping_methods: "روش ارسال ها",
  orders: "سفارش",
  invoices: "فاکتور",
  paymentMethods: "روش پرداخت ها",
  base_definition:"اطلاعات پایه",
  address_list:"لیست آدرس ها"


}
